// extracted by mini-css-extract-plugin
export var modal = "_dj-0";